import { render, staticRenderFns } from "./FooterElement.vue?vue&type=template&id=19e1fcff&scoped=true"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"
import style0 from "./FooterElement.vue?vue&type=style&index=0&id=19e1fcff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1fcff",
  null
  
)

export default component.exports